import AppConstants from '../config/app.constants';

let UserBranchFundingSourceService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/user-branch-funding-source`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let createUserFundingSourceGroup = (userId, fundingSourceData) => {
        return $http
            .post(AppConstants.api + `/user-branch-funding-source/create-user-funding-source-group`, {
                userId,
                fundingSourceData
            })
            .then((res) => {
                return res.data
            })
    }

    let updateUserFundingSourceGroup = (userId, fundingSourceData) => {
        return $http
            .post(AppConstants.api + `/user-branch-funding-source/update-user-funding-source-group`, {
                userId,
                fundingSourceData
            })
            .then((res) => {
                return res.data
            })
    }

    let getBranchFundingSource = (userId, branchId) => {
        return $http
            .get(AppConstants.api + `/user-branch-funding-source/get-branch-funding-source`, {
                params: {
                    userId,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        createUserFundingSourceGroup,
        updateUserFundingSourceGroup,
        getBranchFundingSource
    };

};

UserBranchFundingSourceService.$inject = ['$http', '$q']

export default UserBranchFundingSourceService;


// WEBPACK FOOTER //
// ./client/app/services/user-branch-funding-source.service.js